function enterSubmit() {
	return {
		restrict: "A",
		link: function (scope, elem, attrs) {
			elem.bind("keydown", function (event) {
				var code = event.keyCode || event.which;
				var isDisabled = $(elem).is(":disabled");
				if (code === 13 && !isDisabled) {
					if (!event.shiftKey) {
						event.preventDefault();
						scope.$apply(attrs.enterSubmit);
					}
				}
			});
		}
	};
}

function ngHtmlCompile($compile) {
	return {
		restrict: "A",
		link: function (scope, element, attrs) {
			scope.$watch(attrs.ngHtmlCompile, function (newValue, oldValue) {
				element.html(newValue);
				$compile(element.contents())(scope);
			});
		}
	};
}

function maxHeight() {
	return {
		restrict: "A",
		link: function (scope, element, attributes, $window) {
			var value = attributes.maxHeight;
			element.css("max-height", value);
		}
	};
}

/**
 *
 * Pass all functions into module
 */
angular
	.module("common")
	.directive("enterSubmit", enterSubmit)
	.directive("ngHtmlCompile", ngHtmlCompile)
	.directive("maxHeight", maxHeight);
